import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageMediaLibrary as ManageMediaLibraryContent } from "../components/MediaLibrary/ManageMediaLibrary";

export const ManageMediaLibrary = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageMediaLibraryContent />
        </div>
      </div>
    </div>
  );
};
